const SPECIAL_LAST_ITEMS = ["other"];

export const generateAlphaSort = (field) => {
  return (a, b) => {
    if (SPECIAL_LAST_ITEMS.includes(a[field].toLowerCase())) {
      return 1;
    }
    if (a[field].toLowerCase() > b[field].toLowerCase()) {
      return 1;
    } else if (a[field].toLowerCase() < b[field].toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  };
};
export const sortAlpha = (a, b) => {
  if (a.Description.toLowerCase() > b.Description.toLowerCase()) {
    return 1;
  } else if (a.Description.toLowerCase() < b.Description.toLowerCase()) {
    return -1;
  } else {
    return 0;
  }
};

export const sortInsurerMonthlyTotal = (a, b) => {
  const BIG_NUMBER = 1000000;
  // Where a and b are `insurerModel` objects with a selectedQuote
  // Ensure we sort nulls to the END of the list
  const aPrice = a.selectedQuote?.MonthlyTotal || BIG_NUMBER;
  const bPrice = b.selectedQuote?.MonthlyTotal || BIG_NUMBER;
  return aPrice - bPrice;
};

export const sortQuoteDocsBySortOrder = (a, b) => {
  if (a.sortOrder > b.sortOrder) {
    return 1;
  } else if (a.sortOrder < b.sortOrder) {
    return -1;
  } else {
    return 0;
  }
};

export const addSuccessPageSortOrderToDocs = (doc) => {
  let sortOrder;
  switch (doc.Code) {
    case "quote":
      sortOrder = 1;
      break;
    case "ipid":
      sortOrder = 2;
      break;
    case "terms":
      sortOrder = 3;
      break;
    case "qas":
      sortOrder = 4;
      break;
    case "sdn":
      sortOrder = 5;
      break;
    case "multiquote":
      sortOrder = 6;
      break;
    default:
      sortOrder = 3;
  }
  return { ...doc, sortOrder: sortOrder };
};
